import React from 'react';

export function CadastroInstituicao({ modalData }) {
  return (
    <div>
      {/* "nome_fantasia = 'Hospital Fantasia' */}
      {modalData?.data?.nome ? (
        <span>
          <b>Nome: </b> {modalData?.data?.nome}
        </span>
      ) : (
        ''
      )}

      {/* razao_social = 'Hospital Fantasia com Razão Social' */}
      {modalData?.data?.razao_social ? (
        <span>
          <b>Razão Social: </b> {modalData?.data?.razao_social}
        </span>
      ) : (
        ''
      )}

      {/* silga = 'HFRS'*/}
      {modalData?.data?.sigla ? (
        <span>
          <b>Sigla: </b> {modalData?.data?.sigla}
        </span>
      ) : (
        ''
      )}

      {/* cnes = '1234567' */}
      {modalData?.data?.cnes ? (
        <span>
          <b>CNES: </b> {modalData?.data?.cnes}
        </span>
      ) : (
        ''
      )}

      {/* cep = '18600310' */}
      {modalData?.data?.cep ? (
        <span>
          <b>CEP: </b> {modalData?.data?.cep}
        </span>
      ) : (
        ''
      )}

      {/* logradouro = 'Rua do Hospital Fantasia' */}
      {modalData?.data?.logradouro ? (
        <span>
          <b>Logradouro: </b> {modalData?.data?.logradouro}
        </span>
      ) : (
        ''
      )}

      {/* numero = '234' */}
      {modalData?.data?.numero ? (
        <span>
          <b>Número: </b> {modalData?.data?.numero}
        </span>
      ) : (
        ''
      )}

      {/* complemento = 'bloco 1' */}
      {modalData?.data?.complemento ? (
        <span>
          <b>Complemento: </b> {modalData?.data?.complemento}
        </span>
      ) : (
        ''
      )}

      {/* cidade = 'cidade do Hospital Fantasia' */}
      {modalData?.data?.cidade ? (
        <span>
          <b>Cidade: </b> {modalData?.data?.cidade}
        </span>
      ) : (
        ''
      )}

      {/* estado = 'RS' */}
      {modalData?.data?.estado ? (
        <span>
          <b>Estado: </b> {modalData?.data?.estado}
        </span>
      ) : (
        ''
      )}

      {/* telefone ='5567869986' */}
      {modalData?.data?.telefone ? (
        <span>
          <b>Telefone: </b> {modalData?.data?.telefone}
        </span>
      ) : (
        ''
      )}

    </div>
  );
}
